import { call, put, takeEvery } from 'redux-saga/effects';
import * as api from 'api/userMapping/userMapping';
import {
  CREATE_USER_MAPPING,
  CREATE_USER_MAPPING_UPLOAD,
  DELETE_USER_MAPPING,
  GET_USER_MAPPING,
  UPDATE_USER_MAPPING,
} from 'state/actionTypes';

import * as toastActions from 'state/toast/actions';
import {
  closeDeleteUserMappingModal,
  creatingUserMappingAction,
  creatingUserMappingUploadAction,
  deletingUserMappingAction,
  gettingUserMappingAction,
  getUserMappingSuccess,
  setUserMappingSearchKeyword,
  updatingUserMappingAction,
} from './actions';

export function* getUserMapping({ payload }) {
  try {
    yield put(gettingUserMappingAction(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetUserMapping, payload);
    yield put(getUserMappingSuccess({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get user mapping', error.message)
    );
  } finally {
    yield put(gettingUserMappingAction(false));
  }
}

export function* deleteUserMapping({ payload }) {
  try {
    yield put(deletingUserMappingAction(true));
    yield call(api.performDeleteUserMapping, payload);
    yield put(closeDeleteUserMappingModal());
    yield put(toastActions.successMessage('Successfully deleted user mapping'));
  } catch (error) {
    yield put(toastActions.errorMessage('Failed to delete user mapping'));
  } finally {
    yield put(deletingUserMappingAction(false));
  }
}

export function* updateUserMapping({ payload }) {
  try {
    yield put(updatingUserMappingAction(true));
    yield call(api.performUpdateUserMapping, payload);
    yield put(toastActions.successMessage('Successfully updated user mapping'));
  } catch (error) {
    yield put(toastActions.errorMessage('Failed to update user mapping'));
  } finally {
    yield put(updatingUserMappingAction(false));
  }
}

export function* createUserMapping({ payload }) {
  try {
    yield put(creatingUserMappingAction(true));
    const { data } = yield call(api.performCreateUserMapping, payload);
    yield put(setUserMappingSearchKeyword(data.data.moka.email));
    yield put(toastActions.successMessage('Successfully created user mapping'));
  } catch (error) {
    yield put(toastActions.errorMessage('Failed to create user mapping'));
  } finally {
    yield put(creatingUserMappingAction(false));
  }
}

export function* createUserMappingUpload({ payload }) {
  try {
    yield put(creatingUserMappingUploadAction(true));
    const { data } = yield call(api.performCreateUserMappingUpload, payload);
    yield put(setUserMappingSearchKeyword(''));

    const successCount = data.data.filter(obj => obj.status === 'OK').length;
    if (successCount) {
      yield put(
        toastActions.successMessage(
          `Successfully processing ${successCount} rows`
        )
      );
    }

    const failedData = data.data.filter(obj => obj.status !== 'OK');
    if (failedData.length) {
      for (let i = 0; i < failedData.length; i++) {
        yield put(
          toastActions.errorMessage(
            `Error on row ${failedData[i].row}: ${
              failedData[i].error ? failedData[i].error : undefined
            }`
          )
        );
      }
    }
  } catch (error) {
    yield put(toastActions.errorMessage('Failed to bulk upload user mapping'));
  } finally {
    yield put(creatingUserMappingUploadAction(false));
  }
}

export default function* saga() {
  yield takeEvery(GET_USER_MAPPING, getUserMapping);
  yield takeEvery(DELETE_USER_MAPPING, deleteUserMapping);
  yield takeEvery(UPDATE_USER_MAPPING, updateUserMapping);
  yield takeEvery(CREATE_USER_MAPPING, createUserMapping);
  yield takeEvery(CREATE_USER_MAPPING_UPLOAD, createUserMappingUpload);
}
